(() => {
  if (window.ifThreadsPostValidation) return;
  const script = document.currentScript;
  const message = script?.dataset.invalidPost || 'Enter the link to a Threads post, not a profile.';
  const variants = new Set(["54640544710924", "54640552247564", "44515849077004", "44515848978700", "44515851600140", "44515850027276", "44515849994508", "44515850060044", "44515850387724", "44515851075852", "44515851403532"]);
  const managed = new WeakMap();
  let errorCount = 0;
  function normalize(value) {
    try {
      const raw = String(value || '').trim();
      if (!raw || /[\s\\]/.test(raw)) return '';
      const url = new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`);
      if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.port) return '';
      if (!/^(?:www\.)?threads\.(?:com|net)$/i.test(url.hostname)) return '';
      if (!/^\/(?:@[A-Za-z0-9._]{1,30}\/post|t)\/[A-Za-z0-9_-]+\/?$/.test(url.pathname)) return '';
      url.protocol = 'https:';
      return url.href;
    } catch (_) { return ''; }
  }
  function isVariant(id) { return variants.has(String(id)); }
  function isLikesForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    const fields = [...form.elements];
    const variant = fields.find(field => field.name === 'id');
    const service = fields.find(field => field.name === 'properties[Service]');
    return isVariant(variant?.value) || /threads\s+likes/i.test(service?.value || '');
  }
  function fields(form) {
    return [...form.elements].filter(input => (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) && !input.disabled && input.type !== 'hidden' && (/^properties\[.*threads.*post.*(?:link|url).*\]$/i.test(input.name) || input.hasAttribute('data-username')));
  }
  function configure(input) {
    if (!managed.has(input)) managed.set(input, {required:input.required,placeholder:input.placeholder,inputMode:input.inputMode,error:null});
    input.required = true;
    input.inputMode = 'url';
    input.placeholder = 'https://www.threads.com/@username/post/POST_ID';
    input.setCustomValidity(normalize(input.value) ? '' : message);
  }
  function showError(input) {
    configure(input);
    const state = managed.get(input);
    if (!state.error) {
      const error = document.createElement('p');
      error.id = `threads-post-error-${++errorCount}`;
      error.setAttribute('role', 'alert');
      error.style.cssText = 'color:#b91c1c;font-size:12px;line-height:1.4;margin:6px 0;';
      input.after(error);
      state.error = error;
      input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
    }
    state.error.textContent = message;
    state.error.hidden = false;
    input.setAttribute('aria-invalid', 'true');
  }
  function clearError(input) {
    const state = managed.get(input);
    if (state?.error) state.error.hidden = true;
    input.removeAttribute('aria-invalid');
  }
  function validate(form) {
    if (!isLikesForm(form)) return true;
    let inputs = fields(form);
    if (!inputs.length) {
      const input = document.createElement('input');
      input.type = 'text';
      input.name = 'properties[Threads post link]';
      input.setAttribute('aria-label', message);
      input.style.cssText = 'display:block;width:100%;min-height:44px;padding:10px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;';
      form.append(input);
      inputs = [input];
    }
    for (const input of inputs) {
      configure(input);
      const url = normalize(input.value);
      if (!url) { showError(input); input.focus(); input.reportValidity(); return false; }
      clearError(input);
      input.value = url;
    }
    return true;
  }
  function scan() {
    document.querySelectorAll('form').forEach(form => {
      for (const input of fields(form)) {
        if (isLikesForm(form)) configure(input);
        else if (managed.has(input)) {
          const state = managed.get(input);
          input.required = state.required;
          input.placeholder = state.placeholder;
          input.inputMode = state.inputMode;
          input.setCustomValidity('');
          clearError(input);
          state.error?.remove();
          if (state.error) input.setAttribute('aria-describedby', (input.getAttribute('aria-describedby') || '').split(' ').filter(id => id !== state.error.id).join(' '));
          managed.delete(input);
        }
      }
    });
  }
  window.ifThreadsPostValidation = {normalize,isVariant,message};
  document.addEventListener('submit', event => {
    if (!validate(event.target)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('button,input[type="submit"]') : null;
    if (button?.type === 'submit' && button.form && !validate(button.form)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  for (const type of ['input','change','focusin']) document.addEventListener(type, event => {
    const input = event.target;
    if ((input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) && isLikesForm(input.form) && fields(input.form).includes(input)) {
      configure(input);
      if (normalize(input.value)) clearError(input);
    }
    if (type === 'change') requestAnimationFrame(scan);
  }, true);
  document.addEventListener('invalid', event => {
    const input = event.target;
    if (isLikesForm(input.form) && fields(input.form).includes(input)) showError(input);
  }, true);
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; scan(); });
  }).observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['name','value']});
  scan();
})();
